import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSsn]',
  standalone: true
})
export class SsnDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private control: NgControl
  ) {}

  @HostListener('input')
  @HostListener('paste')
  @HostListener('blur')
  onInput() {
    setTimeout(() => {
      let value = this.el.nativeElement.value.replace(/\D/g, '').substring(0, 9);
      let formatted = value;

      if (value.length > 5) {
        formatted = value.substring(0, 3) + '-' + value.substring(3, 5) + '-' + value.substring(5);
      } else if (value.length > 3) {
        formatted = value.substring(0, 3) + '-' + value.substring(3);
      }

      if (this.el.nativeElement.value !== formatted) {
        this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
        this.control.control?.setValue(formatted, { emitEvent: false });
      }

      this.control.control?.markAsTouched();
      this.control.control?.updateValueAndValidity();
    }, 0);
  }
}